export const finiteLocaleNumber = (value: unknown): number | undefined => {
  const numeric =
    typeof value === "number"
      ? value
      : Number(String(value).replace(/,/g, ""));
  if (!Number.isFinite(numeric)) return undefined;
  return Object.is(numeric, -0) ? 0 : numeric;
};

export const canonicalLocaleDecimalMax2 = (
  value: unknown,
): string | undefined => {
  const numeric = finiteLocaleNumber(value);
  return numeric === undefined
    ? undefined
    : new Intl.NumberFormat("en-US", {
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(numeric);
};

export const formatLocaleDecimalMax2 = (
  value: unknown,
  locales?: Intl.LocalesArgument,
): string | undefined => {
  const numeric = finiteLocaleNumber(value);
  return numeric === undefined
    ? undefined
    : numeric.toLocaleString(locales, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
};
